import React from "react";
import { useParams, Link } from "react-router-dom";
import RoboticsShell from "./RoboticsShell";

/**
 * Individual Robotics hero page.
 *
 * Phase 1: shell only. The real page (Phase 4) will host the Clarke
 * storybook drama player. For now it just names the drama and shows a
 * coming-soon marker.
 */
const DRAMAS = {
  arthur_clarke: {
    title: "Sir Arthur C. Clarke",
    subtitle: "The man who dreamed the satellite",
    scenes: 5,
    minutes: 2,
  },
  clarke_orbit: {
    title: "Clarke's Orbit",
    subtitle: "The 1945 prediction",
    scenes: 5,
    minutes: 2,
  },
};

export default function RoboticsMeetDetail() {
  const { slug } = useParams();
  const drama = DRAMAS[slug];

  if (!drama) {
    return (
      <RoboticsShell>
        <section className="rbx-page" data-testid="rbx-page-meet-notfound">
          <span className="rbx-eyebrow">404 · Unknown drama</span>
          <h1 className="rbx-page__title">This drama isn&rsquo;t in the queue.</h1>
          <p className="rbx-page__lede">
            Only two dramas are planned for the MVP: <code style={{ fontFamily: "var(--rbx-font-mono)", color: "var(--rbx-copper)" }}>arthur_clarke</code> and{" "}
            <code style={{ fontFamily: "var(--rbx-font-mono)", color: "var(--rbx-copper)" }}>clarke_orbit</code>.
          </p>
          <Link className="rbx-btn rbx-btn--ghost" to="/robotics/meet" data-testid="rbx-meet-back">
            ← Back to Meet
          </Link>
        </section>
      </RoboticsShell>
    );
  }

  return (
    <RoboticsShell>
      <section className="rbx-page" data-testid={`rbx-page-meet-${slug}`}>
        <span className="rbx-eyebrow">Storybook drama · {drama.scenes} scenes · ~{drama.minutes} min</span>
        <h1 className="rbx-page__title" data-testid="rbx-drama-title">{drama.title}</h1>
        <p className="rbx-page__lede" data-testid="rbx-drama-subtitle">{drama.subtitle}.</p>
        <div className="rbx-coming-soon" data-testid="rbx-drama-status">
          Ships in Phase 4
        </div>
        <div style={{ marginTop: "24px" }}>
          <Link className="rbx-btn rbx-btn--ghost" to="/robotics/meet">← Back to Meet</Link>
        </div>
      </section>
    </RoboticsShell>
  );
}
